<template>
  <div>
    <b-modal
      :id="modalName"
      no-close-on-backdrop
      no-close-on-esc
      centered
      hide-header
      hide-footer
      hide-header-close
      hide-backdrop
      class="text-left"
      :size="nextIsClicked ? form.blockSize >= 30 ? 'xl' : 'lg' : null"
    >
      <b-overlay :show="showOverlay" rounded="sm">
        <div style="height: auto">
          <!-- <span v-if="selectedBlockSize===0" class="text-danger">尚未学习此词库任何单字</span> -->
          <b-form v-if="showForm">
            <div class="custom-form-content-container">
              <b-form-group
                label="起始题号"
                label-for="initSeq"
                :description="`范围从 1 ~ ${maxSeqOfGlossary}`"
              >
                <b-form-input
                  id="initSeq"
                  class="text-center"
                  v-model="form.initSeq"
                  :state="validateInitSeq"
                  placeholder="请输入正整数"
                  @change="onChangeInitSeq"
                  required
                ></b-form-input>
                <b-form-invalid-feedback :state="validateInitSeq"
                  >不可超出范围</b-form-invalid-feedback
                >
                <b-form-valid-feedback :state="validateInitSeq"
                  >设定有效</b-form-valid-feedback
                >
              </b-form-group>
              <b-form-group
                label="练习题数"
                label-for="numberOfWords"
                :description="`范围从 ${blockSizeRangeStart} ~ ${blockSizeRangeEnd}`"
              >
                <b-form-spinbutton
                  id="numberOfWords"
                  step="1"
                  wrap
                  v-model="form.blockSize"
                  :min="blockSizeRangeStart"
                  :max="blockSizeRangeEnd"
                  :state="validateBlockSize"
                  required
                ></b-form-spinbutton>

                <!-- <b-form-input
                  id="numberOfWords"
                  v-model="form.blockSize"
                  :state="validateBlockSize"
                  placeholder="请输入正整数"
                  required
                ></b-form-input>-->
                <b-form-invalid-feedback :state="validateBlockSize"
                  >不可超出范围</b-form-invalid-feedback
                >
                <b-form-valid-feedback :state="validateBlockSize"
                  >设定有效</b-form-valid-feedback
                >
              </b-form-group>
            </div>

            <div class="button-container">
              <b-button
                block
                class="custom-button five"
                @click="backToVocabulary"
                >&lt; {{ $t("Common.back") }}</b-button
              >
              <b-button
                block
                class="custom-button four"
                @click="showNextStep"
                :disabled="!(validateInitSeq && validateBlockSize)"
                >{{ $t("Common.nextStep") }} &gt;</b-button
              >
            </div>
          </b-form>

          <div v-show="showWords" style="height: 100%">
            <div class="custom-form-content-container">
              <div
                v-if="mode === 'LEARNNEW' || (mode === 'REVIEW' && isUpgraded)"
              >
                <div v-if="!isUpgraded" class="form-header">
                  <span>请勾选已认识的字，勾选后将进行确认。</span>
                  <br />
                  <span>不勾选，将进行练习。</span>
                </div>
                <div v-else class="form-header">
                  <span v-if="mode === 'LEARNNEW'"
                    >请勾选要学习的字，勾选后将进行练习。</span
                  >
                  <span v-if="mode === 'REVIEW'"
                    >请勾选要复习的字，勾选后将开始复习。</span
                  >
                </div>
                <div class="text-left">
                  <b-form-group>
                    <template v-slot:label>
                      <b-form-checkbox
                        id="selectAllCheckBoxGroup"
                        v-model="allSelected"
                        :indeterminate="indeterminate"
                        aria-describedby="selectedWords"
                        aria-controls="selectedWords"
                        @change="onChangeSelectAll"
                        class="font-weight-bold text-primary-50"
                        >{{
                          !allSelected
                            ? $t("Common.selectAll")
                            : $t("Common.cancelSelectAll")
                        }}</b-form-checkbox
                      >
                    </template>
                    <b-form-checkbox-group
                      id="words-checkbox-group"
                      v-model="selectedWords"
                      size="lg"
                    >
                      <div v-if="form.blockSize >= 30">
                        <b-row
                          v-for="i in Math.ceil(wordList.length / 3)"
                          :key="i"
                        >
                          <b-col
                            cols="4"
                            v-for="(word, idx) in wordList.slice(
                              (i - 1) * 3,
                              i * 3
                            )"
                            :key="idx"
                          >
                            <b-form-checkbox :value="word.id">
                              <span>{{ word.word }} - {{ word.meaning }}</span>
                            </b-form-checkbox>
                            <b-icon-volume-up-fill v-if="word.us_pron && word.us_pron.length > 0" @click="playAudio(word.us_pron)"></b-icon-volume-up-fill>
                            <b-icon-volume-up-fill v-else-if="word.uk_pron && word.uk_pron.length > 0" @click="playAudio(word.uk_pron)"></b-icon-volume-up-fill>
                          </b-col>
                        </b-row>
                      </div>
                      <div v-else>
                        <b-row
                          v-for="i in Math.ceil(wordList.length / 2)"
                          :key="i"
                        >
                          <b-col
                            cols="6"
                            v-for="(word, idx) in wordList.slice(
                              (i - 1) * 2,
                              i * 2
                            )"
                            :key="idx"
                          >
                            <b-form-checkbox :value="word.id">
                              <span>{{ word.word }} - {{ word.meaning }}</span>
                            </b-form-checkbox>
                            <b-icon-volume-up-fill v-if="word.us_pron && word.us_pron.length > 0" @click="playAudio(word.us_pron)"></b-icon-volume-up-fill>
                            <b-icon-volume-up-fill v-else-if="word.uk_pron && word.uk_pron.length > 0" @click="playAudio(word.uk_pron)"></b-icon-volume-up-fill>
                          </b-col>
                        </b-row>
                      </div>
                    </b-form-checkbox-group>
                  </b-form-group>
                  <div v-if="isUpgraded && mode === 'REVIEW'" class="mt-5">
                    <b-form-group
                      label="每字练习次数"
                      label-for="practiceTimes"
                      :description="`范围从 ${1} ~ ${
                        currentRule.threshold_frequency_learning + 50
                      }`"
                    >
                      <b-form-spinbutton
                        id="practiceDuration"
                        step="1"
                        wrap
                        v-model="form.practiceTimes"
                        :min="1"
                        :max="currentRule.threshold_frequency_learning + 50"
                        :state="validatePracticeTimes"
                        required
                      ></b-form-spinbutton>
                    </b-form-group>
                  </div>
                </div>
              </div>
              <div
                v-else-if="
                  (mode === 'REVIEW' && !isUpgraded) || mode === 'FORCEREVIEW'
                "
              >
                <div class="form-header">
                  <span>接下来将复习以下单字</span>
                  <!-- <span
                    v-if="mode === 'FORCEREVIEW' && !isUpgraded"
                    class="sub-form-header"
                  >
                    {{ `（范围 ${rangeStart} ~ ${rangeEnd}）` }}
                  </span> -->
                </div>
                <div
                  class="text-left text-success"
                  style="font-size: 20px; margin: 5px"
                >
                  <div v-if="form.blockSize >= 60">
                    <b-row v-for="i in Math.ceil(wordList.length / 6)" :key="i">
                      <b-col
                        cols="2"
                        v-for="(word, idx) in wordList.slice(
                          (i - 1) * 6,
                          i * 6
                        )"
                        :key="idx"
                      >
                        <span>{{ word.word }}</span>
                      </b-col>
                    </b-row>
                  </div>
                  <div v-else-if="form.blockSize >= 30">
                    <b-row v-for="i in Math.ceil(wordList.length / 3)" :key="i">
                      <b-col
                        cols="4"
                        v-for="(word, idx) in wordList.slice(
                          (i - 1) * 3,
                          i * 3
                        )"
                        :key="idx"
                      >
                        <span>{{ word.word }}</span>
                      </b-col>
                    </b-row>
                  </div>
                  <div v-else>
                    <b-row v-for="i in Math.ceil(wordList.length / 2)" :key="i">
                      <b-col
                        cols="6"
                        v-for="(word, idx) in wordList.slice(
                          (i - 1) * 2,
                          i * 2
                        )"
                        :key="idx"
                      >
                        <span>{{ word.word }}</span>
                      </b-col>
                    </b-row>
                  </div>
                </div>
                <div v-if="isUpgraded" class="mt-5">
                  <b-form-group
                    label="每字练习次数"
                    label-for="practiceTimes"
                    :description="`范围从 ${1} ~ ${
                      currentRule.threshold_frequency_learning + 50
                    }`"
                  >
                    <b-form-spinbutton
                      id="practiceDuration"
                      step="1"
                      wrap
                      v-model="form.practiceTimes"
                      :min="1"
                      :max="currentRule.threshold_frequency_learning + 50"
                      :state="validatePracticeTimes"
                      required
                    ></b-form-spinbutton>
                  </b-form-group>
                </div>
              </div>
            </div>
            <div class="button-container">
              <b-button
                v-if="mode !== 'FORCEREVIEW'"
                block
                class="custom-button five"
                @click="backToPrevious"
                >&lt; 返回</b-button
              >
              <b-button
                v-else
                block
                class="custom-button five"
                @click="backToVocabulary"
                >&lt; 返回</b-button
              >
              <b-button
                block
                class="custom-button four"
                :disabled="disableStartTestAndPractice"
                @click="startTestAndPractice"
                >开始 &gt;</b-button
              >
            </div>
          </div>
        </div>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { MODES } from '../vocabularyMode'
import SafeAudio from '../../../util/SafeAudio'

export default {
  name: 'QuestionnaireModal',
  props: {
    modalName: {
      type: String,
      required: true
    },
    showPracticeView: {
      type: Function,
      required: true
    },
    showTestView: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      showPracticeButton: false,
      showLastButton: false,
      showWords: false,
      showOverlay: false,
      showForm: true,
      shown: false,
      form: {
        initSeq: 0,
        blockSize: 0,
        practiceTimes: 0
      },
      allSelected: false,
      indeterminate: false,
      selectedWords: [],
      nextIsClicked: false,
      rangeStart: 0,
      rangeEnd: 0
    }
  },
  watch: {
    selectedWords (newVal, oldVal) {
      if (newVal.length === 0) {
        this.indeterminate = false
        this.allSelected = false
      } else if (newVal.length === this.wordList.length) {
        this.indeterminate = false
        this.allSelected = true
      } else {
        this.indeterminate = true
        this.allSelected = false
      }
    }
  },
  computed: {
    ...mapState({
      wait: (state) => state.vocabularyPractice.wait,
      mode: (state) => state.vocabularyPractice.mode,
      currentRule: (state) => state.vocabularyPractice.currentRule,
      chosenGlossary: (state) => state.glossary.chosenGlossary,
      initSeq: (state) => state.glossary.initSeq,
      maxSeqOfGlossary: (state) => state.glossary.maxSeqOfGlossary,
      isUpgraded: (state) => state.vocabularyPractice.isUpgraded,
      wordList: (state) => state.vocabularyPractice.wordList,
      knownList: (state) => state.vocabularyPractice.knownList,
      selectedInitSeq: (state) => state.vocabularyPractice.selectedInitSeq,
      selectedBlockSize: (state) => state.vocabularyPractice.selectedBlockSize,
      upgradedUserForceReviewWordList: (state) =>
        state.glossary.upgradedUserForceReviewWordList
    }),
    blockSizeRangeStart () {
      if (this.form.initSeq > this.maxSeqOfGlossary) {
        return 0
      } else if (
        this.maxSeqOfGlossary - this.form.initSeq <
        this.currentRule.block_size_lower_limit
      ) {
        return 1
      } else {
        return this.currentRule.block_size_lower_limit
      }
    },
    blockSizeRangeEnd () {
      if (this.form.initSeq > this.maxSeqOfGlossary) {
        return 0
      } else if (
        this.maxSeqOfGlossary - this.form.initSeq >=
        this.currentRule.block_size_upper_limit
      ) {
        return this.currentRule.block_size_upper_limit
      } else {
        return this.maxSeqOfGlossary - this.form.initSeq + 1
      }
    },
    validateInitSeq () {
      return this.form.initSeq <= this.maxSeqOfGlossary
    },
    validateBlockSize () {
      if (
        this.maxSeqOfGlossary - this.form.initSeq <
        this.currentRule.block_size_lower_limit
      ) {
        // 如果起始題號離最大seq距離小於10
        return (
          this.form.blockSize > 0 &&
          this.form.blockSize <= this.maxSeqOfGlossary - this.form.initSeq + 1
        )
      } else {
        // 一般状态
        return (
          this.form.blockSize >= this.currentRule.block_size_lower_limit &&
          this.form.blockSize <= this.currentRule.block_size_upper_limit
        )
      }
    },
    validatePracticeTimes () {
      return (
        this.form.practiceTimes >= 1 &&
        this.form.practiceTimes <=
          this.currentRule.threshold_frequency_learning + 50
      )
    },
    disableStartTestAndPractice () {
      if (this.isUpgraded) {
        if (this.mode === MODES.FORCEREVIEW) {
          return false
        }
        if (this.selectedWords.length === 0) {
          return true
        }
      }
      return false
    }
  },
  methods: {
    showModal () {
      this.allSelected = false
      this.form.practiceTimes = this.currentRule.threshold_frequency_learning
      if (this.mode === MODES.FORCEREVIEW) {
        this.showOverlay = true
        this.showWords = false
        this.showForm = true
        this.nextIsClicked = true
        if (this.isUpgraded || this.mode === MODES.FORCEREVIEW) {
          this.$store
            .dispatch('vocabularyPractice/fetchWords', {
              glossary: this.chosenGlossary,
              upgradedUserForceReviewWordList: this
                .upgradedUserForceReviewWordList
            })
            .then((res) => {
              this.showOverlay = false
              this.showWords = true
              this.showForm = false
              this.allSelected = false
            })
        } else if (this.selectedInitSeq && this.selectedBlockSize) {
          this.rangeStart = this.selectedInitSeq
          this.rangeEnd = this.selectedInitSeq + this.selectedBlockSize - 1
          this.form.initSeq = this.selectedInitSeq
          this.form.blockSize = this.selectedBlockSize
          this.$store
            .dispatch('vocabularyPractice/fetchWords', {
              initSeq: this.selectedInitSeq,
              blockSize: this.selectedBlockSize,
              glossary: this.chosenGlossary
            })
            .then((res) => {
              this.showOverlay = false
              this.showWords = true
              this.showForm = false
              this.allSelected = false
            })
        }
      } else {
        this.form.initSeq = this.initSeq
        if (
          this.maxSeqOfGlossary - this.initSeq >=
          this.currentRule.block_size_upper_limit
        ) {
          this.form.blockSize = this.currentRule.block_size_upper_limit
        } else {
          this.form.blockSize = this.maxSeqOfGlossary - this.initSeq + 1
        }
        this.showWords = false
        this.showForm = true
      }
      this.$bvModal.show(this.modalName)
      this.shown = true
    },
    closeModal () {
      this.$bvModal.hide(this.modalName)
      this.shown = false
    },
    onChangeInitSeq (value) {
      if (this.form.initSeq > this.maxSeqOfGlossary) {
        this.form.blockSize = 0
      } else if (
        this.maxSeqOfGlossary - this.form.initSeq >=
        this.currentRule.block_size_upper_limit
      ) {
        this.form.blockSize = this.currentRule.block_size_upper_limit
      } else {
        this.form.blockSize = this.maxSeqOfGlossary - this.form.initSeq + 1
      }
    },
    onChangeSelectAll (checked) {
      this.selectedWords = checked
        ? this.wordList.slice().map((word) => word.id)
        : []
    },
    backToPrevious () {
      this.showWords = false
      this.showForm = true
      this.nextIsClicked = false
    },
    showNextStep () {
      if (!(this.validateInitSeq && this.validateBlockSize)) {
        return
      }

      this.nextIsClicked = true

      this.showOverlay = true
      this.$store
        .dispatch('vocabularyPractice/fetchWords', {
          initSeq: this.form.initSeq,
          blockSize: this.form.blockSize,
          glossary: this.chosenGlossary
        })
        .then((res) => {
          this.showOverlay = false
          this.showForm = false
          this.showWords = true
          this.allSelected = false
        })
    },
    closeModalAndShowPracticeView () {
      this.closeModal()
      this.showPracticeView()
    },
    closeModalAndShowTestView () {
      this.closeModal()
      this.showTestView()
    },
    backToVocabulary () {
      this.$router.replace('/vocabulary')
    },
    startTestAndPractice () {
      if (
        (!this.isUpgraded && this.mode === MODES.NOTEXAM[1]) ||
        this.mode === MODES.FORCEREVIEW
      ) {
        this.selectedWords = this.wordList.slice().map((word) => word.id)
      }

      this.$store
        .dispatch('vocabularyPractice/appendToKnownListAndUnknownList', {
          selectedWords: this.selectedWords,
          practiceTimes: this.form.practiceTimes
        })
        .then(() => {
          if (this.knownList.length > 0) {
            this.closeModalAndShowTestView()
          } else {
            this.closeModalAndShowPracticeView()
          }

          this.nextIsClicked = false
        })
    },
    playAudio (src) {
      const audio = new SafeAudio(src)
      audio.play()
      delete audio.audio
    }
  }
}
</script>

<style lang='scss' scoped>
@import "./styles/QuestionnaireModal.scss";
</style>
